<span *appFeatureFlag="'isTwitterAvailable'" class="social-item-wrapper">
  <a href="https://www.twitter.com/Identibase/"
    target="_blank"
    aria-label="identi on X (Twitter)"
    class="socials-icon">
    <div class="blob-wrapper" [ngClass]="badgeStyleClass"
     [ngStyle]="{ 'width': badgeWrapperSize, 'height': badgeWrapperSize }">
      <svg  class="blob" [ngClass]="badgeStyleClass"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="252"
            height="240"
            viewBox="0 0 252 240">
        <defs>
          <path id="a-3"
                d="M180.899 10.094C147.354-9.33 46.9-3.935 12.816 54.88c-34.084 58.816 6.385 145.87 44.786 168.083 65.29 37.77 126.894 9.892 160.978-48.923 34.084-58.816 28.418-125.725-37.681-163.946">
          </path>
        </defs>
        <g fill="none" fill-rule="evenodd" transform="translate(7)">
          <mask id="b-3" fill="#fff">
            <use xlink:href="#a-3"></use>
          </mask>
          <use fill-rule="nonzero" xlink:href="#a-3"></use>
          <g fill-rule="nonzero" mask="url(#b-3)">
            <path d="M-7-1h253v241H-7z"></path>
          </g>
        </g>
      </svg>
      <div class="blob-content">
        <span [ngStyle]="{ 'font-size': badgeIconSize, 'display': 'flex', 'align-items': 'center' }">
          <svg [attr.width]="badgeIconSize" [attr.height]="badgeIconSize" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.737-8.835L1.254 2.25H8.08l4.259 5.631 5.905-5.631Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z"/>
          </svg>
        </span>
      </div>
    </div>
  </a>
</span>
